import React from 'react'

const OrderIcon = ({
  size = 24, 
  color = "currentColor",
  strokeWidth = 1.5 
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M14.0927 16.2872H8.64941" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="square"
      />
      <path 
        d="M12.0313 12.504H8.64844" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="square"
      />
      <path 
        fillRule="evenodd" 
        clipRule="evenodd" 
        d="M14.5679 2.75L4.3252 2.75V21.25H19.6745V8.06826L14.5679 2.75Z" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="square"
      />
      <path 
        d="M14.0918 3.30469V8.65011H19.1989" 
        stroke={color} 
        strokeWidth={strokeWidth} 
        strokeLinecap="square"
      />
    </svg>
  )
}

export default OrderIcon